import { registerComponent, storeNumbersMatch } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "preferred-store-button",
  class PreferredStoreButton extends WYATTElement {
    constructor() {
      super();

      this.makePreferred = this.querySelector("[data-make-preferred-button]");
      this.isPreferred = this.querySelector("[data-is-preferred-button]");
      this.onPreferredStoreChange = this.handlePreferredStoreChange.bind(this);

      this.makePreferred.removeAttribute("disabled");
      this.makePreferred.addEventListener("click", this.handleClick.bind(this));
    }

    connectedCallback() {
      this.subscribe(
        WYATT.PubSub.events.preferredStoreChange,
        this.onPreferredStoreChange,
      );
    }

    handleClick(event) {
      event.preventDefault();

      WYATT.PreferredStores.setStore(this.config.store);
    }

    handlePreferredStoreChange(store) {
      if (!store) {
        return;
      }

      if (
        storeNumbersMatch(this.config.store.store_number, store.store_number)
      ) {
        this.setAttribute("data-is-preferred", "");
        this.makePreferred.classList.add("hidden");
        this.isPreferred.classList.remove("hidden");
      } else {
        this.removeAttribute("data-is-preferred");
        this.makePreferred.classList.remove("hidden");
        this.isPreferred.classList.add("hidden");
      }
    }
  },
);
